var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { Equals, IsArray, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
/**
 * Where the session's Account stands in the office of a registration link
 * (#1834). Only `OPEN` lets it join; every other answer creates nothing.
 */
export var RegistrationLinkJoinStatus;
(function (RegistrationLinkJoinStatus) {
    /** No Person of the Account in that office: „Beitreten“. */
    RegistrationLinkJoinStatus["OPEN"] = "OPEN";
    /** The join created the Account's patient Person there; the app switches in. */
    RegistrationLinkJoinStatus["JOINED"] = "JOINED";
    /** A live Person of the Account is there already, in any role: switch in. */
    RegistrationLinkJoinStatus["ALREADY_MEMBER"] = "ALREADY_MEMBER";
    /** A Person there waits for the Account to accept its join invite. */
    RegistrationLinkJoinStatus["AWAITS_ACCEPTANCE"] = "AWAITS_ACCEPTANCE";
    /** A Person there is linked in any other state (archived, say). */
    RegistrationLinkJoinStatus["CONTACT_OFFICE"] = "CONTACT_OFFICE";
})(RegistrationLinkJoinStatus || (RegistrationLinkJoinStatus = {}));
/**
 * A patient the office manages without a login whose contact address is the
 * Account's verified login address (#1835): „Bist du selbst Max Muster?“. First
 * and last name only.
 */
export class RegistrationLinkAddressMatchDto {
    userId;
    firstName;
    lastName;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], RegistrationLinkAddressMatchDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], RegistrationLinkAddressMatchDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], RegistrationLinkAddressMatchDto.prototype, "lastName", void 0);
/**
 * The join page of a registration link (`/join/:token`, #1834): the location
 * the link belongs to, and what joining would do for the session's Account.
 */
export class RegistrationLinkJoinDto {
    status;
    /**
     * What the office is called to its patients: the link's location (an office
     * has no name of its own, TM-9665).
     */
    officeLocationName;
    officeLocationStreet;
    officeLocationZip;
    officeLocationTown;
    /** The office to switch into: set for `JOINED` and `ALREADY_MEMBER`. */
    officeId;
    /** The Person whose join invite waits: set for `AWAITS_ACCEPTANCE`. */
    userId;
    /**
     * For `OPEN`: the office's patients the Account may say it is, instead of
     * becoming a new one (#1835). Empty otherwise.
     */
    addressMatches;
}
__decorate([
    Expose(),
    IsEnum(RegistrationLinkJoinStatus),
    __metadata("design:type", String)
], RegistrationLinkJoinDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], RegistrationLinkJoinDto.prototype, "officeLocationName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], RegistrationLinkJoinDto.prototype, "officeLocationStreet", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], RegistrationLinkJoinDto.prototype, "officeLocationZip", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], RegistrationLinkJoinDto.prototype, "officeLocationTown", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], RegistrationLinkJoinDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], RegistrationLinkJoinDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => RegistrationLinkAddressMatchDto),
    __metadata("design:type", Array)
], RegistrationLinkJoinDto.prototype, "addressMatches", void 0);
/** „Beitreten“: the patient terms of use and the consent declaration, accepted on the join page. */
export class JoinThroughRegistrationLinkDto {
    acceptedTermsOfUse;
    acceptedConsentDeclaration;
    /**
     * „Ja, das bin ich“: one of the page's `addressMatches`, which the Account
     * takes over instead of becoming a new patient (#1835). Absent for „Nein“ /
     * „Keiner davon“.
     */
    claimUserId;
}
__decorate([
    Equals(true),
    __metadata("design:type", Boolean)
], JoinThroughRegistrationLinkDto.prototype, "acceptedTermsOfUse", void 0);
__decorate([
    Equals(true),
    __metadata("design:type", Boolean)
], JoinThroughRegistrationLinkDto.prototype, "acceptedConsentDeclaration", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], JoinThroughRegistrationLinkDto.prototype, "claimUserId", void 0);
//# sourceMappingURL=registration-link-join.js.map